import Vue from 'vue';
import VueRouter from 'vue-router';

// Routes
import { routes } from './routes.js'

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: routes,
});

router.afterEach((to, from) => {
    // Set page title
    let prefix = process.env.VUE_APP_TITLE;
    if (to.meta.title) {
        document.title = prefix + ' | ' + to.meta.title;
    } else {
        document.title = prefix;
    }
});